import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router, ActivatedRoute } from '@angular/router';
import { UserRoleService } from '../../../../services/user-role.service';
import { User } from 'src/app/data/models/user.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CompanyService } from 'src/app/services/company.service';
import * as Roles from '../../../../data/constants/roles';
import { PageEvent } from '@angular/material/paginator';
import { debounceTime, map, filter, takeUntil, take } from 'rxjs/operators';
import { fromEvent, Subscription } from 'rxjs';
import { Subject } from 'rxjs';
import { ApiServicesService } from 'src/app/modules/beneficiary/services/api-services.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UpdateUserCountComponent } from '../update-user-count/update-user-count.component';
import { DeleteUserComponent } from '../delete-user/delete-user.component';
import { UpgradeAccountComponent } from '../upgrade-account/upgrade-account.component';
import { CustomErrorToastComponent } from 'custom-error-toast';
import { USER_PERMISSIONS } from 'app-models';

@Component({
  selector: 'user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
  providers: [DialogService],
})

export class UserListComponent implements OnInit, OnDestroy {
  isCreateAndEdit = false;
  employeeList: User[] = [];
  displayedColumns: string[] = ['name', 'lastname', 'company', 'designation', 'action'];
  dataSource: MatTableDataSource<User>;
  listCompany: object[];
  showDdr: boolean;
  pageSize = 25; // default
  pageIndex = 0; // default
  searchText = '';
  totalElementCount = 0;
  searchSubscription: Subscription;
  // userCountSubscription: Subscription;
  parameterId = null;
  observableSubscription$ = new Subject();
  showInviteButton = false;
  currentCompanyId: number;
  ref: DynamicDialogRef;
  currentUserType: string;
  tempUserInfo: string;
  userCount: number;
  isTextCleared: boolean = false;
  isAssociateCompany: boolean = false;
  currentListCompanyName: string;
  items: MenuItem[];
  rowData;
  isVisibleDetails: boolean;
  
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('userListTable', { static: true }) userListTable: ElementRef;
  constructor(
    private userRoleService: UserRoleService,
    private apiService: ApiServicesService,
    private toastService: ToastrService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private route: ActivatedRoute, private authenticationService: AuthenticationService,
    private companyApiService: CompanyService,
    public dialogService: DialogService,
  ) { }

  ngOnInit() {
    this.currentUserType = localStorage.getItem('userTypeRole');
    if(sessionStorage.getItem('selectedCompanyName')){ 
      this.isVisibleDetails = true;
    } else {
      this.isVisibleDetails = this.currentUserType === 'Petitioner';
    }
    if(JSON.parse(sessionStorage.getItem('associateCompany'))){
      this.isAssociateCompany = true;
    } else {
      this.isAssociateCompany = false;
    }
    this.searchSetUp();
    this.getusersList();
    sessionStorage.removeItem('userrole');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('employeeId');
    
    if(this.currentUserType=='Platform'){
      if(this.router.url.indexOf('/platform-admin-landing/companies/') > -1){
        this.tempUserInfo = 'petitioner';
      } else if(this.router.url.indexOf('/platform-admin-landing/attorneys/') > -1){
        this.tempUserInfo = 'attorney';
      }
    } else if(this.currentUserType=='Petitioner'){
      this.tempUserInfo = 'petitioner';
    } else if(this.currentUserType=='Attorney'){
      this.tempUserInfo = 'attorney';
    }
  }

  searchSetUp() {
    this.searchSubscription = fromEvent(this.userListTable.nativeElement, 'keyup').pipe(
      map((event: any) => event.target.value)
      , filter(res => res.length > 2)
      , debounceTime(1000)).subscribe((text: string) => {
        if (this.dataSource.paginator) {
          this.dataSource.paginator.firstPage();
        }
        this.searchText = text.trim();
        this.getusersList();
      });
  }

  onSearchChange(event){
    if(!event){
      this.searchText = '';
      this.pageIndex = 0;
      this.isTextCleared = true;
      this.getusersList();
    } else {
      this.isTextCleared = false;
    }
  }

  getusersList() {
    if(this.isTextCleared){
      this.searchText = '';
    }
    const payload = {
      pageNumber: this.pageIndex,
      recordsPerPage: this.pageSize,
      searchText: this.searchText
    };
    this.route.params
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(parameter => {
        this.parameterId = null;
        if (parameter.hasOwnProperty('id')) {

          this.parameterId = parameter.id;
          this.showInviteButton = true;
          this.displayedColumns = ['name', 'lastname', 'company', 'designation', 'email', 'action'];
        }
      });
    const companyId = this.parameterId == null ? parseInt(sessionStorage.getItem('selectedCompanyId')) : parseInt(this.parameterId);
    this.currentCompanyId = companyId;
    this.userRoleService.getUsersList(companyId, payload).subscribe((user: any) => {
      this.employeeList = user.employees || [];
      if(this.employeeList.length!==0){
        this.currentListCompanyName = this.employeeList[0]['company']?.companyName;
      } else {
        this.currentListCompanyName = sessionStorage.getItem('selectedCompanyName');
      }
      if(this.currentListCompanyName!==sessionStorage.getItem('selectedCompanyName')){
        this.isAssociateCompany = false;
      }
      this.dataSource = new MatTableDataSource(this.employeeList);
      this.totalElementCount = user.totalCount || 0;
      this.dataSource.sort = this.sort;
      this.getNoOfUsers(); 
    });
  }

  getNoOfUsers(){
    this.userRoleService.getCompanyUsersCount(this.currentCompanyId).pipe(takeUntil(this.observableSubscription$)).subscribe((user: any) => {
      if(user){
        this.userCount = user;
      }
    });
  }

  createNewUser() {
    this.companyApiService.getCompanyHierarchyUserInfo(this.currentCompanyId).pipe(takeUntil(this.observableSubscription$)).subscribe((data: any) => {
      if(data.data){
        sessionStorage.removeItem('userrole');
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('employeeId');
        if (!this.showInviteButton) {
          this.router.navigate(['../newuser'], { relativeTo: this.route, state: { editMode: true } });
        } // Im-3125
        else {
          this.router.navigate(['../../newuser'], { relativeTo: this.route, state: { editMode: true, clientId: this.parameterId } });
        } // Im-3125
      } else {
        this.upgradeAccount();
      }
    });
  }

  sendInviteToClient(element) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to send invite?',
      header: 'Send Invite',
      accept: () => {
        this.apiService.sendInviteToClient(parseInt(this.parameterId), parseInt(element.id))
          .subscribe((result: any) => {
            if (result) {
              this.toastService.success(result.message, 'Success');
            }
            else {
              CustomErrorToastComponent.showErrorToast(this.toastService, result.message);
            }
          });
      },
      reject: () => {
      }
    });

  }

  handleEdit(input) {
    console.log(input);
    sessionStorage.setItem('user', JSON.stringify(input));
    sessionStorage.setItem('empId', input.id);
    // sessionStorage.setItem('companyId', input.company.id);
    if (!this.showInviteButton) {
      this.router.navigate(['../newuser'], { relativeTo: this.route, state: { editMode: true } });
    } // Im-3125
    else {
      if(input?.isPrimaryContactPerson==1){
        sessionStorage.setItem('currentPrimary', 'true');
      } else {
        sessionStorage.removeItem('currentPrimary'); 
      }
      this.router.navigate(['../../newuser'], { relativeTo: this.route, state: { editMode: true, clientId: this.parameterId } });
    } // Im-3125

  }
  paginationEvent(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.getusersList();
  }
  // resetSearch(event) {
  //   console.log('eventevent', event);
  //   this.searchText = ''; // reset search
  //   this.pageIndex = 0; // reset search
  //   this.getusersList();
  // }

  onClickUpdateUserCount() {
    this.ref = this.dialogService.open(UpdateUserCountComponent, {
      header: "Update User Counts",
      width: "600px",
      data: {
        companyId: this.currentCompanyId,
        count: this.userCount,
        userType: this.currentUserType
      },
      contentStyle: { "max-height": "800px", overflow: "auto" },
    });

    this.ref.onClose.subscribe((result) => {
      if(result){
        this.ngOnInit();
      }
    });
  }

  onClickDeleteUser(data) {
    this.ref = this.dialogService.open(DeleteUserComponent, {
      header: "Delete User",
      width: "600px",
      data: {
        employeeId: data.id,
        companyId: data.company.id,
        userInfo: this.tempUserInfo
      },
      contentStyle: { "max-height": "800px", overflow: "auto" },
    });

    this.ref.onClose.subscribe((result) => {
      if (result) {
        this.ngOnInit();
      }
    });
  }

  upgradeAccount() {
    this.ref = this.dialogService.open(UpgradeAccountComponent, {
      header: "Add User",
      width: "600px",
      data: {
        companyId: this.currentCompanyId,
        count: this.userCount,
        userType: this.currentUserType
      },
      contentStyle: { "max-height": "800px", overflow: "auto" },
    });

    this.ref.onClose.subscribe((result) => {
      if (result) {
      }
    });
  } 

  toggleMenu(menu, event, rowData) {
    this.rowData = rowData;
    this.items = [
      {
        label: 'Edit',
        command: (event) => {
          this.handleEdit(this.rowData);       
        },
        visible: USER_PERMISSIONS.EDIT_EMPLOYEES ? true : false
      },
      {
        label: 'Send Invite',
        command: (event) => {
          this.sendInviteToClient(this.rowData);
        },
        visible: this.showInviteButton && !this.isVisibleDetails
      }, 
    ];
    menu.toggle(event);
  }

  handleView(input, mode) {

  }


  ngOnDestroy() {
    this.searchSubscription.unsubscribe();
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }
}
